import { Trans } from '@lingui/react/macro'
import React from 'react'

import ConnectWallet from '@/components/ConnectWallet'
import { Text } from '@/components/ui/Text'
import { cn } from '@/lib/utils'

const Header: React.FC<React.HTMLAttributes<HTMLElement>> = (props) => {
  return (
    <header {...props} className={cn('header flex items-center justify-between', props.className)}>
      {/* <img src="favicon.svg" alt={Description} /> */}
      <Text as="h2" className="text-base xs:font-bold sm:text-lg">
        <Trans>MCN Chain Bridge</Trans>
      </Text>
      <ConnectWallet />
    </header>
  )
}

export default Header
